import { CustomerOrder } from "@omni/types/api/cart/bff/customerOrder.model";
import { Button } from "@omni/ui/components/Button/button.component";
import { Divider } from "@omni/ui/components/Divider/divider.component";
import * as CustomerOrderUtils from "@omni/utils/customerOrder.utils";
import { cn } from "@omni/utils/styles";

import OrderItem from "@/components/Account/OrderList/Order/OrderItem/orderItem.component";
import { Container } from "@/components/General/Grid/container.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    setActive: (id: string | null) => void;
    activeId: string | null;
    orderId: string;
    order: CustomerOrder;
};

const Order = ({ setActive, activeId, orderId, order }: Props) => {
    const { t } = useGranite();
    const onlyFirst = activeId !== orderId;
    const validItems = order.items.filter(
        (item) =>
            CustomerOrderUtils.getTitle(item, t) &&
            !item.warrantyDeposit &&
            !CustomerOrderUtils.productIsAdditionalService(order.items, item.id)
    );

    return (
        <Container>
            {validItems
                .slice(0, onlyFirst ? 1 : validItems.length)
                .map((item, index) => (
                    <OrderItem
                        key={`${item.sku}-${orderId}`}
                        item={item}
                        index={index}
                        orderId={orderId}
                    />
                ))}
            {validItems.length > 1 && (
                <>
                    <Divider
                        marginTop="0"
                        className={"my-2 mt-sm-0"}
                    />
                    <Row>
                        <div className="col text-right">
                            <Button
                                test="order-button-toggle"
                                type="button"
                                className={cn(
                                    "tw:no-underline! tw:px-0 tw:pt-0 tw:mr-[1.4%]"
                                )}
                                color="link"
                                onClick={() =>
                                    setActive(onlyFirst ? orderId : null)
                                }
                            >
                                <span className={"pr-2"}>
                                    {t(
                                        `general.${
                                            onlyFirst ? "open" : "close"
                                        }`
                                    )}
                                </span>
                                <i
                                    className={cn(
                                        "tw:text-base",
                                        `las la-chevron-circle-${
                                            onlyFirst ? "down" : "up"
                                        }`
                                    )}
                                />
                            </Button>
                        </div>
                    </Row>
                </>
            )}
        </Container>
    );
};

export default Order;
